/**
 * Colorway-cirklar pa tyg-/tapetkorten (snippets/bf2-product-card.liquid).
 *
 * Klick pa en swatch byter kortbilden till den colorwayns variantbild och
 * pekar om kortlanken till varianten, kunden ser fargstallningen direkt i
 * griden utan att ga in pa produkten.
 *
 * Delegerad lyssnare pa document: overlever att filter (AJAX) och oandlig
 * scroll byter ut hela grid-innehallet, ingen om-init behovs.
 */
document.addEventListener('click', (event) => {
    const swatch = event.target.closest('.bf2-product__swatch[data-swap-src]');
    if (!swatch) return;

    const card = swatch.closest('a.bf2-product');
    if (!card) return;

    // Swatchen ligger inuti kortets <a>: stoppa navigeringen.
    event.preventDefault();
    event.stopPropagation();

    const img = card.querySelector('.bf2-product__img img');
    if (img) {
        if (swatch.dataset.swapSrcset) {
            img.srcset = swatch.dataset.swapSrcset;
        } else {
            img.removeAttribute('srcset');
        }
        img.src = swatch.dataset.swapSrc;
    }

    // Klickar kunden vidare in pa produkten ska PDP:n landa pa samma colorway.
    if (swatch.dataset.variantId) {
        try {
            const url = new URL(card.getAttribute('href'), window.location.origin);
            url.searchParams.set('variant', swatch.dataset.variantId);
            card.setAttribute('href', url.pathname + url.search);
        } catch {
            /* trasig href, lat kortlanken vara */
        }
    }

    card.querySelectorAll('.bf2-product__swatch.is-active').forEach((el) => el.classList.remove('is-active'));
    swatch.classList.add('is-active');
});
